import { Box } from "@mui/material"
import { VStack } from "goi_common"

function SangjoPage() {
    return <VStack>
        <Box>프리드라이프, 등록번호 서울-2010-제4호, 대표이사 김만기, 영업개시일 2002-02-21, 선불식할부거래업 등록일 2010-09-29, 법인등록번호 230111-0083681, 사업자등록번호 610-81-56858, 총 선수금 1,955,273,360,666,
            <br />
            법인소재지: 서울특별시 중구 세종대로 14 13층
            <br />
            전자우편번호 admin@preed.co.kr<br />

            재무 현황(2022년 12월 말 기준)
            - 지급여력비율: 114% (전체 평균: 97%)
            - 부채 비율: 88% (전체 평균: 103%)

            선수금 보전 현황 (51%)
        </Box>
    </VStack>
}

export default SangjoPage